import React, { useState } from "react";
import { Smile } from "lucide-react";
import { GS_EMOJIS, EmojiText } from "@/lib/emoji";

export function EmojiButton({ onPick, testid = "emoji-btn", className = "", inline = false }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" data-testid={testid} onClick={() => setOpen((o) => !o)} className={`text-slate-400 p-1 ${className}`}><Smile className="w-5 h-5" /></button>
      {open && (
        <div data-testid={`${testid}-picker`} className={inline ? "basis-full w-full mt-2" : "fixed left-0 right-0 bottom-36 z-50 md:max-w-2xl md:mx-auto px-4"}>
          <div className="grid grid-cols-5 gap-2 p-3 bg-white rounded-3xl border border-slate-100 shadow-xl max-h-64 overflow-y-auto">
            {GS_EMOJIS.map((em, i) => (
              <button type="button" key={em} data-testid={`${testid}-emoji-${i + 1}`} onClick={() => { onPick(em); setOpen(false); }} className="active:scale-90 transition-transform">
                <img src={`/emoji/e${i + 1}.webp?v=2`} alt="" className="w-full aspect-square" draggable={false} />
              </button>
            ))}
          </div>
        </div>
      )}
    </>
  );
}

export function EmojiPreview({ text, testid }) {
  if (!/:gs\d+:/.test(text || "")) return null;
  return <div data-testid={testid || "emoji-preview"} className="text-sm text-slate-700 break-words mt-1 px-1"><EmojiText body={text} /></div>;
}
